import axios from 'axios';

axios.defaults.timeout = 5000;
//axios.defaults.baseURL = '';

//http request 拦截器
axios.interceptors.request.use(
    config => {
        // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
        // config.data = JSON.stringify(config.data);
        // config.headers = {
        //         'Content-Type': 'application/x-www-form-urlencoded'
        //     }
        // if(token){
        //   config.params = {'token':token}
        // }
        // 这里写死一个token，你需要在这里取到你设置好的token的值
        // const token = sessionStorage.getItem("token");

        const token = JSON.parse(localStorage.getItem("cloudUser")) ? JSON.parse(localStorage.getItem("cloudUser")).cloudToken : "";
        console.log(token)
        if (token) {
            // 这里将token设置到headers中，header的key是Authorization，这个key值根据你的需要进行修改即可
            config.headers.cloudToken = token;
        }
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);



/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(response => {
                if (response.data.status == 1) {
                    resolve(response.data.data);
                } else {
                    reject(response)
                  let msg
                  if(response.msg){
                    msg = response.msg
                  }else{
                    msg = response.data.msg
                  }
                  this.$message.error(msg, 3)
                }
            })
            .catch(err => {
                reject(err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                console.log(response.data)
                if (response.data.status == 1) {
                    resolve(response.data.data);
                } else {
                  let msg
                  if(response.msg){
                    msg = response.msg
                  }else{
                    msg = response.data.msg
                  }
                    this.$message.error(msg, 3)
                    reject(response)
                }
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}



// WEBPACK FOOTER //
// ./src/utils/http.js